import {Component, OnInit} from '@angular/core';
import {MessageDisplayModel} from 'src/app/shared/message/messageDisplay.model';
import {customEmailNFValidator} from 'src/app/shared/custom-validators/custom-email.validator';
import {phoneNumberNFValidator} from 'src/app/shared/custom-validators/phone-number.validator';
import {CompanyContact} from 'src/app/shared/models/company-contract.model';
import {MyProfileService} from 'src/app/shared/services/my-profile.service';
import {MessageDisplayService} from 'src/app/shared/services/message-display.service';
import {AdminRolesCompaniesService} from 'src/app/shared/services/admin-roles-companies.service';
import {Router} from '@angular/router';
import {SessionStorageService} from 'src/app/shared/services/session-storage.service';
import {OAuthUserInfo} from 'src/app/shared/models/oauthuserinfo.model';
import {COUNTRIES} from 'src/utilities/constants/misc.constants';
import {FIRST_LAST_PATTERN} from 'src/utilities/constants/first-last-name.regex';
import {NUM_AND_SPACE} from 'src/utilities/constants/number-and-space.regex';
import {InternationalPhonePipe} from 'src/app/shared/pipes/international-phone.pipe';
import {NoSpaceIntPhonePipe} from 'src/app/shared/pipes/no-space-int-phone.pipe';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-company-contacts',
  templateUrl: './company-contacts.component.html',
  styleUrls: ['./company-contacts.component.scss']
})
export class CompanyContactsComponent implements OnInit {

  userId: string; // this is the logged in user's info

  companyName: string;
  formMessage: MessageDisplayModel = new MessageDisplayModel();

  companiesMap: any = {};
  companies: string[] = [];

  companyContacts: CompanyContact[] = [];

  formIsWaiting = false;
  hasCompanyContactFormBeenSubmitted = false;

  public contact1PhoneCode: string;
  public contact2PhoneCode: string;
  defaultContact1PhoneFlag: string;
  defaultContact2PhoneFlag: string;
  public countries = COUNTRIES;

  public countryFlags = this.countries.map(e => e.flag);
  public countryCodes = this.countries.map(e => e.code);
  public countryNames = this.countries.map(e => e.name);

  numAndSpaceRegEx = new RegExp(NUM_AND_SPACE);

  input = {
    selectedCompany: '',
    contact1: {
      name: '',
      email: '',
      workPhone: '',
      seq: -1,
    },
    contact2: {
      name: '',
      email: '',
      workPhone: '',
      seq: -1,
    }
  };

  formHasError = false;
  formError = {
    company: false,
    contact1: {
      name: false,
      email: false,
      workPhone: false,
      workPhoneInvalid: false,
    },
    contact2: {
      name: false,
      email: false,
      workPhone: false,
      workPhoneInvalid: false,
    }
  };

  constructor(
    private router: Router,
    private myProfileService: MyProfileService,
    private messageDisplay: MessageDisplayService,
    private sessionStorage: SessionStorageService,
    private adminRolesCompanies: AdminRolesCompaniesService,
    private intPhonePipe: InternationalPhonePipe,
    private noSpaceIntPhonePipe: NoSpaceIntPhonePipe,
    private titleService: Title
  ) {

    this.sessionStorage.userInfosChange.subscribe((userInfo: string) => {
      if (userInfo) {
        const user: OAuthUserInfo = JSON.parse(userInfo);
        this.userId = user.sub;
      }
    });

  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Contact Us');
    this.adminRolesCompanies.companiesMap$.subscribe((companyMap: any) => {
      if (companyMap) {
        this.companiesMap = companyMap;
        this.companies = Object.keys(this.companiesMap);
        this.input.selectedCompany = this.companies[0];
        this.companyName = this.companies[0];
        console.log('COMPANIES MAP: ', companyMap);
        if (this.companyName) {
          this.loadData();
        }
      }
    });
  }

  loadData() {
    this.myProfileService.getCompanyContactsByCompany(this.companiesMap[this.companyName]).then((result: CompanyContact[]) => {
      this.companyContacts = result;
      console.log('Company contacts: ', result);

      if (result[0]) {
        const contact1Phone = result[0].phoneNbr !== '' ? result[0].phoneNbr : result[0].phoneNbr;
        if (contact1Phone.length > 10) {
          const phoneCode =
            contact1Phone.split(' ').join('').split('').filter(c => c !== '-')
              .join('').split('').filter(c => c !== '(').join('').split('')
              .filter(c => c !== ')').join('').slice(0, contact1Phone.length - 10);
          this.defaultContact1PhoneFlag = this.countryFlags[this.countryCodes.indexOf(phoneCode)];
        } else {
          this.defaultContact1PhoneFlag = '🇺🇸';
        }

        this.input.contact1.seq = result[0].contactSeqNbr;
        this.input.contact1.name = result[0].contactName;
        this.input.contact1.email = result[0].emailAddr;
        this.input.contact1.workPhone = contact1Phone;
        this.workPhoneChange1();
      }

      if (result[1]) {
        const contact2Phone = result[1].phoneNbr !== '' ? result[1].phoneNbr : result[1].phoneNbr;
        if (contact2Phone.length > 10) {
          const phoneCode =
            contact2Phone.split(' ').join('').split('').filter(c => c !== '-').join('')
              .split('').filter(c => c !== '(').join('').split('').filter(c => c !== ')')
              .join('').slice(0, contact2Phone.length - 10);
          this.defaultContact2PhoneFlag = this.countryFlags[this.countryCodes.indexOf(phoneCode)];
        } else {
          this.defaultContact2PhoneFlag = '🇺🇸';
        }

        this.input.contact2.seq = result[1].contactSeqNbr;
        this.input.contact2.name = result[1].contactName;
        this.input.contact2.email = result[1].emailAddr;
        this.input.contact2.workPhone = contact2Phone;
        this.workPhoneChange2();
      }

    });
  }

  setCompany() {
    this.companyName = this.input.selectedCompany;

    this.formMessage = null;
    this.messageDisplay.clearMessage();
    this.input = {
      selectedCompany: '',
      contact1: {
        name: '',
        email: '',
        workPhone: '',
        seq: -1,
      },
      contact2: {
        name: '',
        email: '',
        workPhone: '',
        seq: -1,
      }
    };

    if (this.companyName) {
      this.loadData();
    }
  }

  contactFactory(companyId, contactName, contactPhoneCode, contactPhone, contactEmail, contactSeqNbr, createdUserId) {
    if (contactPhone === '') {
      contactPhoneCode = '';
    }
    return {
      CompanyId: companyId,
      ContactName: contactName,
      PhoneNbr: contactPhoneCode +
        contactPhone.split(' ').join('').split('').filter(c => c !== '-').join('').split('').filter(c => c !== '(')
        .join('').split('').filter(c => c !== ')').join(''),
      Email: contactEmail,
      SeqNbr: contactSeqNbr,
      CreatedUserId: createdUserId
    };

  }

  validForm() {

    this.formHasError = false;
    this.formError = {
      company: false,
      contact1: {
        name: false,
        email: false,
        workPhone: false,
        workPhoneInvalid: false,
      },
      contact2: {
        name: false,
        email: false,
        workPhone: false,
        workPhoneInvalid: false,
      }
    };

    // Check the contact 1 fields
    if (this.input.contact1.name !== '' || this.input.contact1.workPhone !== '' || this.input.contact1.email !== '') {
      if (this.input.contact1.name === '' || !FIRST_LAST_PATTERN.test(this.input.contact1.name)) {
        this.formHasError = true;
        this.formError.contact1.name = true;
      }

      if (this.input.contact1.email === '' || customEmailNFValidator(this.input.contact1.email)) {
        this.formHasError = true;
        this.formError.contact1.email = true;
      }

      if (this.input.contact1.workPhone === '') {
        this.formHasError = true;
        this.formError.contact1.workPhone = true;
      } else if (!this.numAndSpaceRegEx.test(this.input.contact1.workPhone)) {
        this.formHasError = true;
        this.formError.contact1.workPhoneInvalid = true;
      } else if (phoneNumberNFValidator(this.contact1PhoneCode + this.input.contact1.workPhone) != null) {
        this.formHasError = true;
        this.formError.contact1.workPhoneInvalid = true;
      }
    }

    // Check the contact 2 fields
    if (this.input.contact2.name !== '' || this.input.contact2.workPhone !== '' || this.input.contact2.email !== '') {
      if (this.input.contact2.name === '' || !FIRST_LAST_PATTERN.test(this.input.contact2.name)) {
        this.formHasError = true;
        this.formError.contact2.name = true;
      }

      if (this.input.contact2.email === '' || customEmailNFValidator(this.input.contact2.email)) {
        this.formHasError = true;
        this.formError.contact2.email = true;
      }

      if (this.input.contact2.workPhone === '') {
        this.formHasError = true;
        this.formError.contact2.workPhone = true;
      } else if (!this.numAndSpaceRegEx.test(this.input.contact2.workPhone)) {
        this.formHasError = true;
        this.formError.contact2.workPhoneInvalid = true;
      } else if (phoneNumberNFValidator(this.contact2PhoneCode + this.input.contact2.workPhone) != null) {
        this.formHasError = true;
        this.formError.contact2.workPhoneInvalid = true;
      }
    }

    return !this.formHasError;
  }

  submitForm() {

    console.log('Form submitted', this.input);

    this.formIsWaiting = true;
    this.hasCompanyContactFormBeenSubmitted = true;

    if (!this.validForm()) {
      this.formIsWaiting = false;
      this.hasCompanyContactFormBeenSubmitted = false;
      return;
    }

    const companyIdData = this.companiesMap[this.companyName];
    const createdUserIdData = this.userId;

    // Contact 1
    if (this.input.contact1.seq > 0) {
      this.myProfileService.updateCompanyContact(this.contactFactory(
        companyIdData,
        this.input.contact1.name,
        this.contact1PhoneCode,
        this.input.contact1.workPhone,
        this.input.contact1.email,
        this.input.contact1.seq,
        createdUserIdData)).catch(() => {
        this.formMessage =
          this.messageDisplay.createErrorMessageDisplayWithGivenMessage(
            'A problem was encountered when creating the company contacts');
        this.formIsWaiting = false;
      });
    } else if (this.input.contact1.email || this.input.contact1.email || this.input.contact1.workPhone) {
      this.input.contact1.seq = 1;
      this.myProfileService.createCompanyContact(this.contactFactory(
        companyIdData,
        this.input.contact1.name,
        this.contact1PhoneCode,
        this.input.contact1.workPhone,
        this.input.contact1.email,
        this.input.contact1.seq,
        createdUserIdData)).catch(() => {
        this.formMessage =
          this.messageDisplay.createErrorMessageDisplayWithGivenMessage(
            'A problem was encountered when creating the company contacts');
        this.formIsWaiting = false;
      });
    }


    // Contact 2
    if (this.input.contact2.seq > 0 &&
      this.input.contact2.name === '' &&
      this.input.contact2.email === '' &&
      this.input.contact2.workPhone === '') {
      // if the fields have been cleared then delete the entry;
      this.myProfileService.deleteCompanyContact({
        companyId: companyIdData,
        createdUserId: createdUserIdData,
        seq: this.input.contact2.seq
      }).catch(() => {
        this.formMessage =
          this.messageDisplay.createErrorMessageDisplayWithGivenMessage(
            'A problem was encountered when deleting an contact');
        this.formIsWaiting = false;
      });
    } else if (this.input.contact2.seq > 0) {
      this.myProfileService.updateCompanyContact(this.contactFactory(
        companyIdData,
        this.input.contact2.name,
        this.contact2PhoneCode,
        this.input.contact2.workPhone,
        this.input.contact2.email,
        this.input.contact2.seq,
        createdUserIdData)).catch(() => {
        this.formMessage =
          this.messageDisplay.createErrorMessageDisplayWithGivenMessage(
            'A problem was encountered when creating the company contacts');
        this.formIsWaiting = false;
      });
    } else if (this.input.contact2.email || this.input.contact2.name || this.input.contact2.workPhone) {
      this.input.contact2.seq = 2;
      this.myProfileService.createCompanyContact(this.contactFactory(
        companyIdData,
        this.input.contact2.name,
        this.contact2PhoneCode,
        this.input.contact2.workPhone,
        this.input.contact2.email,
        this.input.contact2.seq,
        createdUserIdData)).catch(() => {
        this.formMessage =
          this.messageDisplay.createErrorMessageDisplayWithGivenMessage(
            'A problem was encountered when creating the company contacts');
        this.formIsWaiting = false;
      });
    }

    this.formIsWaiting = false;

    // if no message, display success message
    this.formMessage =
      this.messageDisplay.createSuccessMessageDisplayWithGivenMessage(
        `Contacts for ${this.companyName} have been saved!`);

  }

  public setContact1PhoneCode(flag) {
    this.contact1PhoneCode = this.countryCodes[this.countryFlags.indexOf(flag)];
  }

  public setContact2PhoneCode(flag) {
    this.contact2PhoneCode = this.countryCodes[this.countryFlags.indexOf(flag)];
  }

  workPhoneChange1() {
    if (this.contact1PhoneCode === '+1') {
      const maskedVal = this.intPhonePipe.transform(this.input.contact1.workPhone);
      if (this.input.contact1.workPhone !== maskedVal) {
        this.input.contact1.workPhone = maskedVal;
      }
    } else {
      const maskedVal = this.noSpaceIntPhonePipe.transform(this.input.contact1.workPhone);
      if (this.input.contact1.workPhone !== maskedVal) {
        this.input.contact1.workPhone = maskedVal;
      }
    }
  }

  workPhoneChange2() {
    if (this.contact2PhoneCode === '+1') {
      const maskedVal = this.intPhonePipe.transform(this.input.contact2.workPhone);
      if (this.input.contact2.workPhone !== maskedVal) {
        this.input.contact2.workPhone = maskedVal;
      }
    } else {
      const maskedVal = this.noSpaceIntPhonePipe.transform(this.input.contact2.workPhone);
      if (this.input.contact2.workPhone !== maskedVal) {
        this.input.contact2.workPhone = maskedVal;
      }
    }
  }
}
